import { styled } from 'styled-components';

export const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledContent = styled.div`
  flex: 1 0 auto;
`;
